import { render } from "./CarouselItem.vue?vue&type=template&id=f3769944"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import "./CarouselItem.vue?vue&type=style&index=0&id=f3769944&lang=css"

import exportComponent from "/home/patrick/Documents/olympe/marketplace/templates/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/web/Carousel/CarouselItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3769944"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3769944', __exports__)) {
    api.reload('f3769944', __exports__)
  }
  
  module.hot.accept("./CarouselItem.vue?vue&type=template&id=f3769944", () => {
    api.rerender('f3769944', render)
  })

}


export default __exports__